import { Outlet } from 'react-router-dom'
import Sidebar from '../components/SideBar'
import Header from '../components/Header'
import '../assets/styles/AdminLayout.css'
import { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import { useLogout } from '../hooks/useLogout'
export default function AdminLayout() {
  const [UserName, setUserName] = useState('Usuário não logado')
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const logout = useLogout();

  useEffect(() => {
    // Buscar dados do usuário no localStorage
    const usuarioLogado = localStorage.getItem('usuario');
    if (usuarioLogado) {
      try {
        const usuario = JSON.parse(usuarioLogado);
        setUserName(usuario.nome || 'Usuário sem nome');
      } catch (error) {
        console.error('Erro ao parsear dados do usuário:', error);
        setUserName('Erro ao carregar usuário');
      }
    } else {
      setUserName('Usuário não logado');
    }
  }, [])


  return (
    <div style={{ backgroundColor: "var(--background-color)" }}>

      <div className='login-box'>
        <h1>Sistema de Acompanhamento Rural (SAR)</h1>
        <h2>{UserName}</h2>
        <nav style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src='/assets/images/login.jpg'
    className='user-img'
    alt='logo'
    onClick={() => setDropdownOpen(!dropdownOpen)}
    style={{ cursor: 'pointer', borderRadius: '50%', width: '40px', height: '40px' }}
  />

  {dropdownOpen && (
    <div className='dropdownMenu'>
      <div
        onClick={() => { setDropdownOpen(false); /* ação desejada */ }}
        className='menuItemStyle'
      >
      <NavLink to="/Configuracoes/Perfil" className="no-link-style">
            Perfil
          </NavLink>
      </div>
      <div
        onClick={() => { setDropdownOpen(false); /* ação desejada */ }}
        className='menuItemStyle'
      >
      <NavLink to="/Login" className="no-link-style">
            Login
          </NavLink>
      </div>
      
      <div
        onClick={() => { setDropdownOpen(false); logout(); }}
        className='menuItemStyle'
      >
        <NavLink className="no-link-style">
            Sair
          </NavLink>
      </div>
    </div>
  )}
</nav>
      </div>

      <div className='admin-layout'>
        <Sidebar />
        <div className='main-content'>
          <Header />
          <div className='page-content'>
            <Outlet />
            
          </div>
          <p style={{ textAlign: 'end', margin: '16px 0', fontSize: '12px', color: '#888' }}>Desenvolvido por Softstone</p>
        </div>
      </div>
    </div>
  )
}
